import { isFunction } from './common';
import { LOGGER } from '../constant';

let subscribers = [];
const logPriorityMap = { [LOGGER.INFO]: 20, [LOGGER.DEBUG]: 30 };

function getEventCallback(argsArr) {
  const obj = { event: LOGGER.INFO, callback: null };
  if (argsArr.length === 1) {
    obj.callback = argsArr[0];
  } else if (argsArr.length === 2) {
    obj.callback = argsArr[1];
    obj.event = argsArr[0];
  }
  return obj;
}

export const pubsubLogger = {
  publish(event, data) {
    if (subscribers.length === 0) return;
    subscribers.forEach(subsObj => {
      if (logPriorityMap[event] <= logPriorityMap[subsObj.logLavel]) {
        subsObj.callback(data);
      }
    });
  },
  info(data) {
    this.publish(LOGGER.INFO, data);
  },
  debug(data) {
    this.publish(LOGGER.DEBUG, data);
  },
  subscribe(...args) {
    const { event, callback } = getEventCallback(Array.prototype.slice.call(args));
    if (!isFunction(callback)) {
      throw new Error('Callback must be a function');
    }

    if (typeof event !== 'string') {
      throw new Error('event name must be a string');
    }

    const logLavel = event.toUpperCase();
    if (!Object.prototype.hasOwnProperty.call(LOGGER, logLavel)) {
      throw new Error('event name must be a valid string : ', LOGGER);
    }

    const uniqueId = new Date().getTime();
    subscribers.push({ id: uniqueId, logLavel, callback });

    return {
      unsubscribe() {
        subscribers = subscribers.filter(subsObj => uniqueId !== subsObj.id);
      }
    };
  }
};



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/utils/logger.js